import { Component, Inject, ViewChild } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Keys } from 'app/models/core/dropdowns';
import { ISearchLabs, ISearchLabsParameters } from 'app/models/searchLabs/searchLabs';
import { SettingsService } from 'app/services/core/settings.service';
import { SearchLabsService } from 'app/services/searchLabs/searchLabs.service';
import { PDFExportComponent } from '@progress/kendo-angular-pdf-export';
import { SharedService } from '@shared/services/shared.service';
import { LabApplicationMenuService } from 'app/services/application-menu/lab-application-menu.service';
import { IApplicationMethodsViewModel, IApplicationReportViewModel } from 'app/models/reports/reports';

declare const printJS: any;

@Component({
  selector: 'applicationReport',
  templateUrl: './applicationReport.component.html',
  styleUrls: ['./applicationReport.component.scss']
})
export class ApplicationReportComponent {

  @ViewChild('pdf') pdf: PDFExportComponent;
  public appData: IApplicationReportViewModel = {
    applicationType: '',
    applicationId: 0,
    submitter: '',
    submitDate: '',
    datePrinted: '',
    printedBy: '',
    orelapId: '',
    epaId: '',
    laboratoryName: '',
    taxId: '',
    accreditingAuthority: '',
    siteAddress: '',
    siteCity: '',
    siteState: '',
    siteZip: '',
    longitude: '',
    latitude: '',
    mailAddress: '',
    mailCity: '',
    mailState: '',
    mailZip: '',
    billingAddress: '',
    billingCity: '',
    billingState: '',
    billingZip: '',
    ownerName: '',
    ownerAddress: '',
    ownerCity: '',
    ownerState: '',
    ownerZip: '',
    ownerPhone: '',
    labTypeDescription: '',
    labTypeOther: '',
    commercialSamples: '',
    commercialSamplesComments: '',
    drivingDirections: '',
    hoursComments: '',
    weekdays: '',
    applicationMethods: [],
    applicationHours: [],
    applicationPersonnel: []
  };

  public datePrinted: string = new Date().toLocaleDateString('en-US', { year: 'numeric', month: '2-digit', day: '2-digit' });

  public groupedAnalytes: {
    matrix: string,
    tech: {
      technology: string,
      methods: { method: string, analytes: IApplicationMethodsViewModel[] }[]
    }[]
  }[] = [];

  constructor(public searchLabsService: SearchLabsService,
    public settings: SettingsService,
    private dialogRef: MatDialogRef<ApplicationReportComponent>,
    private sharedService: SharedService,
    private labApplicationMenuService: LabApplicationMenuService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.labApplicationMenuService.getApplicationReport(this.sharedService.currentApplication.labId,
      this.sharedService.currentApplication.labApplicationId).subscribe(
        response => {
          // console.log('application report response', response);
          this.appData = response;
          this.groupTechnologies(this.appData.applicationMethods);
        },
        error => console.log('error', error)
      );
  }

  groupTechnologies(methods: IApplicationMethodsViewModel[]): void {
    // First group by name (matrix level)
    const byName: { [key: string]: IApplicationMethodsViewModel[] } = {};
    methods.forEach(m => {
      if (!byName[m.name]) {
        byName[m.name] = [];
      }
      byName[m.name].push(m);
    });

    // Build the nested structure: matrix -> tech -> method -> analytes
    this.groupedAnalytes = Object.keys(byName).map(name => {
      const methodsForName = byName[name];

      // Group by instrumentTechnology
      const byTech: { [key: string]: IApplicationMethodsViewModel[] } = {};
      methodsForName.forEach(method => {
        if (!byTech[method.instrumentTechnology]) {
          byTech[method.instrumentTechnology] = [];
        }
        byTech[method.instrumentTechnology].push(method);
      });

      return {
        matrix: name,
        tech: Object.keys(byTech).map(technology => {
          const methodsForTech = byTech[technology];

          // Group by reference (method)
          const byReference: { [key: string]: IApplicationMethodsViewModel[] } = {};
          methodsForTech.forEach(method => {
            if (!byReference[method.reference]) {
              byReference[method.reference] = [];
            }
            byReference[method.reference].push(method);
          });

          return {
            technology: technology,
            methods: Object.keys(byReference).map(reference => ({
              method: reference,
              analytes: byReference[reference]
            }))
          };
        })
      };
    });
  }

  ngOnInit(): void {
  }

  printReport(): void {
    if (this.pdf) {
      this.pdf.saveAs('ORELAP_Application_Report.pdf');
    }
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

}
